uniform float time;
uniform float progress;
uniform float opacity;
uniform float dir;
uniform float copies;
uniform sampler2D texture1;
uniform vec4 resolution;
varying vec2 vUv;
varying vec3 vPosition;
float PI = 3.141592653589793238;
void main()	{
	// vec2 newUV = (vUv - vec2(0.5))*resolution.zw + vec2(0.5);
	vec2 newUV = vec2(atan(vPosition.x, vPosition.y) / (2.0 * PI) + 0.5, (length(vPosition)-1.)/0.05);
	newUV = vUv;
	newUV.x *=copies;
	newUV.y =1. - newUV.y;
	newUV = fract(newUV - dir*vec2(time*0.01,0.));
	vec4 color = texture2D(texture1, newUV);
	gl_FragColor = vec4(vUv.y,0.,0.0,1.);
	gl_FragColor = color*opacity;
	// gl_FragColor = vec4(fract(vUv.x*100.),0.,0.,1.);
}